import { useNavigate } from 'react-router-dom';

import { NextButton,PrevButton } from '@/shared-components/buttons/components/SliderControls';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import FHSlider from '@/shared-components/sliders/components/FHSlider';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/ImageCategory.css';

function ImageCategoryItem({ item, type }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="search-image-category-item__container" onClick={()=>navigate(`/search/${type}/${item.title.replace(/ /g, "-")}`, { state: { from: true } })}>
        <ArtworkImage 
          image={item.image} 
          imageClassName="search-image-category-item__image" 
          imageTemplateClassName="search-image-category-item__image"
          forceSmaller={300}
          forceSmallerDimension='height'
        />

        <Text className="search-image-category-item__name" small>
          {item.title}
        </Text>
      </div>
    </>
  );
}

export default function ImageCategory({ categoryName, data, type }) {
  return (
    <>
      <div className="search-image-category__container">
        <Heading className="search-image-category__heading" small>
          {categoryName}
        </Heading>

        <FHSlider speed={1.4} className="search-image-category__slider" customPrevButton={<PrevButton/>} customNextButton={<NextButton/>}>
          {data.map(item => <ImageCategoryItem key={item.title} type={type} item={item}/>)}
        </FHSlider>
      </div>
    </>
  );
}
